import React, { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getMuthootBranches, getQuestions, getSubQuestions, resetQuestions } from "slices/questionSlice";
import Questions from "./Questions";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import { useLocation } from "react-router-dom";
import { isDev, isMuthoot, isOrix } from "Routes/Routes";
import { REOPEN_INPROGRESS } from "app/constants";
import { getAnswers } from "slices/answerSlice";

export default function QuestionsContainer({ profile }) {
  const dispatch = useDispatch();

  let {
    questions: { questions },
    disputes: { activeDispute },
    cases: { activeCase },
    answers: { answers },
  } = useSelector((state) => state, shallowEqual);

  const [answerValues, setAnswerValues] = useState(new Map());

  const updateAnswerValues = (key, value) => {
    setAnswerValues((prevMap) => {
      const updatedMap = new Map(prevMap);
      updatedMap.set(key, value);
      return updatedMap;
    });
  };

  useEffect(() => {
    if ((isOrix || isMuthoot) && activeDispute?.status !== 'new') {
      dispatch(getSubQuestions(activeDispute.company_product, activeCase.type, activeDispute?.status === REOPEN_INPROGRESS ? 'dispute reopen' : 'additional details'));
    } else {
      dispatch(getQuestions(activeDispute.company_product, activeCase.type));
    }
    return () => {
      dispatch(resetQuestions());
    };
  }, [activeDispute?.company_product, activeCase?.type, activeDispute?.status]);

  // Fetch answers when activeCase changes
  useEffect(() => {
    if (activeCase?.id) {
      dispatch(getAnswers(activeCase.id)).then((res) => {
        const answers = res.results || [];
        const ansMap = new Map();
        answers.forEach(element => {
          ansMap.set(element.question, element.value);
        });
        setAnswerValues(ansMap);
      });
    }
  }, [activeCase?.id, dispatch]);

  const answerLoading = useSelector((state) => state.answers.loading);

  const location = useLocation();
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (isMuthoot && activeCase.type === 'claimant' && questions?.length > 0) {
      const indexMuthootBranch = questions.findIndex((ques) => ques.name === "Please add the name of the Muthoot Finance Branch where you encountered difficulty.");
      if (indexMuthootBranch > -1 && questions[indexMuthootBranch]['type'] === 'simple') {
        const url = `api/disputes/${activeDispute?.id}/branches/`;
        dispatch(getMuthootBranches(url, indexMuthootBranch, JSON.parse(JSON.stringify(questions))));
      }
    }
  }, [questions])

  const [showGuide, setShowGuide] = useState(
    location.pathname.split("/")[1] == "disputes" && (user.id == 473 || user.id == 214) && !isDev
  );

  const exit = (t) => {
    setShowGuide(false);
  };

  const steps = [
    // {
    //   element: ".introstep1",
    //   intro: "Select the company you wish to file a grievance against.",
    // },
    {
      element: ".introstep2",
      intro: "Fill some answers.",
    },
    // {
    //   element: ".introstep3",
    //   intro: "Upload any necessary documents.",
    // },
    // {
    //   element: ".introstep4",
    //   intro: "Review your grievance details",
    // },
    // {
    //   element: ".introstep5",
    //   intro: "Download your automatically generated grievance here!",
    // },
  ];

  return (
    <Fragment>
      {questions.length > 0 && (
        <>
          <Steps
            enabled={showGuide}
            steps={steps}
            initialStep={0}
            onExit={exit}
            options={{
              hideNext: false,
              hidePrev: true,
              keyboardNavigation: true,
              exitOnEsc: true,
              exitOnOverlayClick: false,
              showBullets: false,
              showStepNumbers: false,
              disableInteraction: true,
              doneLabel: "Next"
            }}
          />
          <Questions
            questions={questions}
            activeDispute={activeDispute}
            activeCase={activeCase}
            answerLoading={answerLoading}
            profile={profile}
            answerValues={answerValues}
            updateAnswerValues={updateAnswerValues}
            fetchedAnswers={answers}
          />
        </>
      )}
    </Fragment>
  );
}
